import { TGRPCPromiseReject } from '@monorepo/grpc';
import { getGrpcClientPromise } from '@monorepo/grpc/utils/getGrpcPromise';
import {
  UploadPricingRequest,
  UploadPricingResponse
} from '@spilca/order_ts/v1/order_web/pricing_web_pb';
import { PricingService } from '@spilca/order_ts/v1/order_web/pricing_web_pb_service';
import { useMutation } from '@tanstack/react-query';

type AddFileMutator = {
  fileData: Uint8Array;
};

const useAddPriceListFile = () => {
  const mutator = ({
    fileData
  }: AddFileMutator): Promise<UploadPricingResponse.AsObject | null> => {
    const request = new UploadPricingRequest();

    request.setContent(fileData);

    return getGrpcClientPromise(PricingService.UploadPricing)(request);
  };

  return useMutation<
    UploadPricingResponse.AsObject | null,
    TGRPCPromiseReject,
    AddFileMutator
  >({
    mutationFn: mutator,
    retry: false
  });
};

export default useAddPriceListFile;
